import { cn } from '~/util';
import { useLocaleDateString } from '~/util/hooks/useLocale';
import { FullBadgeData } from '~/util/types/badges';
import { BadgeIcon } from './BadgeIcon';

export const BadgeInfo = ({
    badge,
    selected,
    onClick,
    showCompletionStatus = true,
}: {
    badge: FullBadgeData;
    selected?: boolean;
    onClick?: () => void;
    showCompletionStatus?: boolean;
}) => {
    const isCompleted = 'unlocked_at' in badge && !!badge.unlocked_at;
    const localeDate = useLocaleDateString();
    return (
        <button
            key={`${badge.badge_code}`}
            className={cn(
                'flex text-left p-2 rounded-xl w-full',
                onClick &&
                    'hover:bg-background-dark cursor-pointer transition-colors',
                showCompletionStatus && !isCompleted && 'text-secondary-light',
            )}
            onClick={onClick}
        >
            <div className="relative size-14">
                <BadgeIcon
                    badge={badge}
                    title={badge.title}
                    className={cn(
                        'absolute top-0 left-0 size-14 overflow-hidden',
                        showCompletionStatus &&
                            !isCompleted &&
                            'grayscale brightness-50',
                        selected && 'scale-120',
                    )}
                />
            </div>
            <div className="ml-2">
                <p className="text-sm font-medium">{badge.title}</p>
                <p className="text-xs">{badge.standard_description}</p>
                {showCompletionStatus && (
                    <p className="text-xs italic text-secondary-light">
                        {isCompleted
                            ? `Unlocked on ${localeDate(badge.unlocked_at!)}`
                            : 'Locked'}
                    </p>
                )}
            </div>
        </button>
    );
};
